import { langObject } from '../assets/LanguageData'
import { updateLanguage } from '../../../src/app/modules/auth/core/_requests' //module "c:/Projects/VDSoftware/AISenseUs/Api/Dashboard/src/app/modules/auth/core/_requests"
const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'
type Props = {
  selectedLang: 'en' | "tr"
}
const initialState: Props = {
  selectedLang: 'en',
}
export function LanguageHelp(text: string) {
  const lang = getConfig()
  const resultKeywordObject = langObject[text as keyof typeof langObject]
  if (resultKeywordObject === undefined){
    console.log("a new keyboard: ", text)
    return text
  }
  const resultKeyword = resultKeywordObject[(lang.selectedLang + "") as keyof typeof resultKeywordObject]
  if (resultKeyword === undefined)
    return text
  return resultKeyword

}

export function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  // console.log(ls, "ls")
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  let initial = initialState
  if (navigator.language.split('-')[0] === "tr") {
    initial.selectedLang = "tr"
    setLanguage(initial.selectedLang, false)
  }
  return initial
}

// Side effect
export function setLanguage(lang: string, reload = true, writeDatabase = false) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({ selectedLang: lang }))
  if (writeDatabase) {
    updateLanguage(lang, reload)
  }
  if (reload && writeDatabase === false) {
    window.location.reload()
  }
}